/* eslint-disable react/jsx-no-bind */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import '@aerialist7/react-dates/initialize';
import moment from 'moment-timezone';
import DateRangePickerWrapper from '../DateRangePickerWrapper';

const DATE_FORMAT = 'YYYY-MM-DD';

// Cloned so the moment the picker holds in its state keeps its own locale.
const formatDate = date => (date ? date.clone().locale('en').format(DATE_FORMAT) : null);

class DateRange extends React.Component {
  static propTypes = {
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    startDatePlaceholderText: PropTypes.string,
    endDatePlaceholderText: PropTypes.string,
    onDatesChange: PropTypes.func.isRequired,
    showClearDates: PropTypes.bool,
    periods: PropTypes.arrayOf(PropTypes.object),
    disabled: PropTypes.bool,
    block: PropTypes.bool,
    emitPartial: PropTypes.bool,
    t: PropTypes.func.isRequired,
  }

  static defaultProps = {
    block: true,
    emitPartial: false,
    showClearDates: true,
    periods: [],
  };

  constructor(props) {
    super(props);
    this.inner = React.createRef();
  }

  setPeriod = (days) => {
    const endDate = moment();
    const startDate = endDate.clone().subtract(days, 'days');
    this.inner.current.setState({ startDate, endDate });
    this.props.onDatesChange(startDate && startDate.locale('en').format(DATE_FORMAT), endDate && endDate.locale('en').format(DATE_FORMAT));
  }

  setAllTime = () => {
    this.inner.current.setState({ startDate: null, endDate: null });
    this.props.onDatesChange(null, null);
  }

  onDatesChange = ({ startDate, endDate }) => {
    // Mirror the picker as it is, half-picked or cleared ranges included, so a
    // form holding the dates never keeps a range the picker no longer shows.
    if (this.props.emitPartial) {
      this.props.onDatesChange(formatDate(startDate), formatDate(endDate));
      return;
    }

    // This is a workaround to handle the case where the user clears the dates
    // by clicking the clear button.
    // The library doesn't provide a way to detect this case, so we have to
    // wait for the dates to be cleared and then check if the values are empty.
    if (startDate === null && endDate === null) {
      setTimeout(() => {
        const elements = document.querySelectorAll('.DateInput_1 input');
        const values = Array.from(elements).map((element) => element.value);

        const startDateString = values[0];
        const endDateString = values[1];

        if (startDateString === '' && endDateString === '') {
          this.setAllTime();
        }
      }, 200);

      return;
    }

    if (startDate && endDate) {
      this.props.onDatesChange(startDate && startDate.locale('en').format(DATE_FORMAT), endDate && endDate.locale('en').format(DATE_FORMAT));
    }
  }

  render() {
    const { startDate, endDate, t } = this.props;
    const start = startDate ? moment(startDate, DATE_FORMAT) : null;
    const end = endDate && moment(endDate, DATE_FORMAT);

    return (
      <Fragment>
        <DateRangePickerWrapper
          ref={this.inner}
          initialStartDate={start}
          initialEndDate={end}
          onDatesChange={this.onDatesChange}
          block={this.props.block}
          showClearDates
          disabled={this.props.disabled}
          startDatePlaceholderText={this.props.startDatePlaceholderText || t('filters.startDate')}
          endDatePlaceholderText={this.props.endDatePlaceholderText || t('filters.endDate')}
        />
        {this.props.periods.length > 0 && (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '4px', fontSize: '12px' }}>
            {this.props.periods.filter((period) => period.days).map((period, index) => (
              <button
                key={index}
                className='link-button link-button--lowercase'
                onClick={() => {
                  if (this.props.disabled) return;
                  this.setPeriod(period.days)
                }}
              >
                {this.props.t('dashboard.periods.' + period.value, period.label)}
              </button>
            ))}
            <button
              className='link-button link-button--lowercase'
              onClick={() => {
                if (this.props.disabled) return;
                this.setAllTime()
              }}
            >
              {this.props.t('nav.allTime')}
            </button>
          </div>
        )}
      </Fragment>
    )
  }
}

export default withTranslation()(DateRange);
